
import { Options } from "vue-class-component";
import { Game } from "../../model/Game.model";
import Base from "../base/Base.vue";
@Options({})
export default class TopChallenge extends Base {
  lstgame: Game[] = [
    {
      id: 1,
      name: "2",
      description: "",
      genre: "",
      imageUrl: "",
      length: "",
      tag: "",
    },
  ];
}
